<template>
  <div v-if="visible" class="cd-backdrop">
    <div class="cd-overlay" @click="$emit('close')"></div>

    <div class="cd-dialog">
      <div class="cd-dialog__title">{{ $t('titleModalCashout') }}</div>

      <div class="cd-dialog__body">
        {{ $t('textPropostCashout1') }}
        <span class="cd-dialog__potential">{{ potentialWin }}</span>
        {{ $t('textPropostCashout2') }}
        <span class="cd-dialog__cashout">{{ cashoutValue }}</span>
      </div>

      <div class="cd-dialog__actions">
        <button class="cd-btn cd-btn--cancel" @click="$emit('close')">
          {{ $t('Disagree') }}
        </button>
        <button class="cd-btn cd-btn--confirm" :disabled="loading" @click="$emit('confirm')">
          <span v-if="loading" class="cd-btn__loading">
            <svg class="cd-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="cd-spinner__track" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="cd-spinner__arc" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>...</span>
          </span>
          <span v-else>{{ $t('Agree') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CashoutDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    cashoutValue: {
      type: String,
      required: true
    },
    potentialWin: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.cd-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cd-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
}

.cd-dialog {
  position: relative;
  background-color: var(--mybets-card-bg, #2a2a2a);
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  width: 100%;
  max-width: 384px;
  margin: 0 16px;
  padding: 20px;
  border: 1px solid var(--mybets-border, rgba(255, 255, 255, 0.1));
}

.cd-dialog__title {
  font-size: var(--font-size-7xl);
  font-weight: 700;
  color: var(--mybets-text, #ffffff);
  margin-bottom: 16px;
}

.cd-dialog__body {
  font-size: var(--font-size-4xl);
  color: var(--mybets-text-muted, rgba(255, 255, 255, 0.5));
  margin-bottom: 24px;
  line-height: 1.5;
}

.cd-dialog__potential {
  color: #ef4444;
  font-weight: 600;
}

.cd-dialog__cashout {
  color: #22c55e;
  font-weight: 600;
}

.cd-dialog__actions {
  display: flex;
  gap: 12px;
}

.cd-btn {
  flex: 1;
  padding: 10px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: var(--font-size-4xl);
  border: none;
  cursor: pointer;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}

.cd-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cd-btn--cancel {
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--mybets-text, #ffffff);
}

.cd-btn--cancel:hover:not(:disabled) {
  background-color: var(--mybets-primary, #e92742);
  color: #ffffff;
}

.cd-btn--confirm {
  background-color: #16a34a;
  color: #ffffff;
}

.cd-btn--confirm:hover:not(:disabled) {
  background-color: #15803d;
}

.cd-btn__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.cd-spinner {
  width: 16px;
  height: 16px;
  animation: cd-spin 1s linear infinite;
}

.cd-spinner__track { opacity: 0.25; }
.cd-spinner__arc { opacity: 0.75; }

@keyframes cd-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
